import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledDemoWrap = styled.div(({ theme }) => {
  return css`
    position: relative;
    width: 50vw;
    min-height: 15vh;
    background: ${theme.base.palette['primary-background']};
    border: 0.0625rem solid ${theme.base.palette['border-line']};
    padding: calc(2 * ${theme.base.spacing});
  `;
});

StyledDemoWrap.defaultProps = defaultThemeProp;
